import React from 'react';
import './style.css'


const footer = () => {
  return (
    <div className='footer'>
      <p className='footer-text'>Copyright 2020 Argent Bank</p>
    </div>
  );
};

export default footer;